module.exports = __webpack_public_path__ + "img/student.20544b07.png";